import { Person } from '../core-data-model/Person.model';
import { RelationshipGuide } from './PatternInsights.interface';

export class RelationshipGuideConfig {
    person1: Person;
    person2: Person;
    relationshipGuide: RelationshipGuide[];
}
